// ============================================================================
// cabinet/useCabinetTabs.ts — живой список вкладок кабинета для оболочки.
// Реестр — SSoT (lib/cabinet/tabs.ts); хук подписывается на его изменения,
// чтобы вкладка, зарегистрированная другим приложением/поставкой, появилась
// без перезагрузки и без правок оболочки.
// ============================================================================

import { useMemo, useSyncExternalStore } from 'react';
import {
  cabinetTabsVersion,
  listCabinetTabs,
  subscribeCabinetTabs,
  type CabinetTab,
} from './tabs';

export function useCabinetTabs(): CabinetTab[] {
  const version = useSyncExternalStore(subscribeCabinetTabs, cabinetTabsVersion, cabinetTabsVersion);
  return useMemo(() => listCabinetTabs(), [version]);
}
